export default [
  {
    path: '/algorithm-runs',
    name: 'algorithm-runs',
    component: () => import('./pages/Index'),
    meta: {
      title: 'Algoritmos',
      icon: 'mdi-robot-outline',
        breadcrumbs: [
          { text: 'Algoritmos', disabled: true, href: '/' },
          { text: 'Execuções', disabled: true, href: '/' },
        ],
      },
  },
  {
    path: '/algorithm-runs/:runId',
    name: 'algorithm-run-show',
    component: () => import('./pages/Show'),
    meta: {
      title: 'Execução',
      icon: 'mdi-robot-outline',
    },
  },
  {
    path: '/algorithm-runs/:runId/results',
    name: 'algorithm-run-results',
    component: () => import('./pages/Results'),
    meta: {
      title: 'Resultados',
      icon: 'mdi-calendar-week-outline',
    },
  },
]
